<template>
  <v-card :class="['disparadores', $v.localChosenSenders.$error ? 'disparadores-error' : '']" height="363px">
    <mf-loading loader-type="dynamic" :dynamic-amount="2" :dynamic-width="100" :boolean-loader="$apollo.queries.senders.loading" fill-height>
      <v-container class="pa-0" fluid fill-height>
        <v-row no-gutters class="pr-3">
          <h3 class="table-card-title pl-4 pt-2">Disparar mensagens dos números</h3>
          <v-spacer />
          <mf-search v-model="search" dense outlined hide-details placeholder="Buscar disparador" />
        </v-row>
        <v-row v-if="$v.localChosenSenders.$error" no-gutters>
          <v-col class="pa-0 pl-4">
            <mf-icon class="disparadores-error-icon" small color="vermelho-l20"> info </mf-icon>
            <span class="disparadores-error-label pl-2 error--text">Selecione ao menos um número para enviar a campanha.</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-data-table
              v-model="localChosenSenders"
              height="205px"
              fixed-header
              hide-default-footer
              disable-pagination
              :headers="headers"
              :items="items"
              item-key="number"
              :show-select="!disabled"
            >
              <template v-slot:item.number="{ item }">
                {{ formatNumber(item.number) }}
              </template>
              <template v-slot:item.status="{ item }">
                <mf-icon fill class="px-2 mb-1" small :color="item.connection_status === 'ONLINE' ? '#26a95d' : '#e74c3c'"> fiber_manual_record </mf-icon>
                <span class="sender-status">{{ capitalize(item.connection_status) }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <warning-row class="pl-4"> Apenas os consumidores que se cadastraram através dos números selecionados irão receber essa campanha </warning-row>
      </v-container>
    </mf-loading>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'
import { capitalize } from 'lodash'
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { required, minLength } from 'vuelidate/lib/validators'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'

const QUERY_GET_NUMBERS = gql`
  query GetNumbers {
    getNumbers(type: SENDER) {
      _id
      name
      number
      connection_status
      nof_contacts
    }
  }
`

export default {
  name: 'Disparadores',
  components: {
    WarningRow: () => import('@/components/WarningRow.vue'),
  },
  props: {
    chosenSenders: Array,
    isMariaCampaign: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localChosenSenders: [],
    search: '',
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Nome',
          value: 'name',
        },
        {
          text: 'Número',
          value: 'number',
        },
        ...(!this.isMariaCampaign
          ? [
              {
                text: 'Contatos',
                value: 'nof_contacts',
              },
            ]
          : []),
        {
          text: 'Status',
          sortable: false,
          value: 'status',
        },
      ]
    },
  },
  apollo: {
    senders: {
      query: QUERY_GET_NUMBERS,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      update({ getNumbers }) {
        if (!getNumbers) return []
        if (this.isMariaCampaign && !this.disabled) {
          if (this.chosenSenders.length) {
            this.localChosenSenders = getNumbers.filter((sender) =>
              this.chosenSenders.map((chosenSender) => (chosenSender?.number ? chosenSender?.number : chosenSender)).includes(sender.number)
            )
          } else {
            this.localChosenSenders = getNumbers
          }
        } else {
          if (this.chosenSenders && this.chosenSenders.length) {
            this.localChosenSenders = getNumbers.filter((sender) => {
              return this.chosenSenders.some((chosen) => chosen.number === sender.number) || this.chosenSenders.includes(sender.number)
            })
          } else {
            this.localChosenSenders = getNumbers
          }
        }
        return getNumbers
      },
    },
  },
  watch: {
    localChosenSenders(value) {
      if (this.localChosenSenders) {
        this.$emit(
          'update:chosenSenders',
          this.localChosenSenders.map((sender) => sender.number)
        )
      }
      this.validate()
    },
    search: {
      handler(value) {
        if (value) {
          const searchRegex = diacriticSpaceSensitiveRegex(value)
          this.items = this.senders.filter((sender) => {
            return sender.name.match(searchRegex) || sender.number.match(searchRegex)
          })
          return
        }
        this.items = this.senders
      },
      immediate: true,
    },
    senders() {
      this.items = this.senders
    },
  },
  methods: {
    capitalize(str) {
      return capitalize(str)
    },
    formatNumber(number) {
      return phoneNumberFormat(number)
    },
    validate() {
      this.$v.$reset()
      this.$v.$touch()
    },
  },
  validations() {
    return {
      localChosenSenders: {
        required,
        minLength: minLength(1),
      },
    }
  },
}
</script>

<style lang="scss">
.disparadores {
  color: $cinza-d10;
  font-size: 14px;
}
.disparadores-error {
  border-left: 5px solid $vermelho-0 !important;
  .disparadores-error-label {
    font-size: 12px;
    letter-spacing: 0.2px;
    color: $vermelho-0;
  }
}
</style>
